import { CustomizerDataType } from "../../Types/Layout/ThemeCustomizerTypes";

export const navLinkList: CustomizerDataType[] = [
    {
        path: 'https://support.pixelstrap.com/',
        image: 'support.png',
        name: 'Support'
    },
    {
        path: 'https://docs.pixelstrap.net/react/mofi/document/',
        image: 'setting.png',
        name: 'Document'
    },
    {
        path: 'https://landing.pixelstrap.net/react/mofi/template/landing-page.html',
        image: 'features.png',
        name: 'Check Features'
    },
    {
        path: 'https://themeforest.net/user/pixelstrap/portfolio',
        image: 'document.png',
        name: 'Buy Now'
    }
]